import { api, ApiError, URLs } from '@/libs/api'
import type { ApiResponse, FortnoxConnection, FortnoxConnectResponse } from '@/libs/interfaces'
import { fortnoxApiMock } from '@/libs/mocks/handlers/fortnox'

const fortnoxApiReal = {
  // The backend 404s when the org has never connected Fortnox — that's the normal
  // "not connected" state, not a failure, so it resolves to `undefined`.
  getConnection: async (orgID: string): Promise<FortnoxConnection | undefined> =>
    api
      .get<ApiResponse<FortnoxConnection>>(
        URLs.Fortnox.connection(orgID),
        undefined,
        undefined,
        true,
      )
      .then((response) => response.data.data)
      .catch((error: unknown) => {
        if (error instanceof ApiError && error.status === 404) return undefined
        throw error
      }),

  connect: async (orgID: string): Promise<FortnoxConnectResponse> =>
    api
      .get<ApiResponse<FortnoxConnectResponse>>(URLs.Fortnox.connect(orgID))
      .then((response) => response.data.data),

  disconnect: async (orgID: string): Promise<void> => {
    await api.delete(URLs.Fortnox.connection(orgID))
  },
}

export const fortnoxApi: typeof fortnoxApiReal = __IS_MOCK_MODE__ ? fortnoxApiMock : fortnoxApiReal
